import { Alert, type AlertProps, Snackbar, type SnackbarProps } from "@mui/material";
import type { ReactNode, ReactElement } from "react";

interface ToastProps extends Omit<SnackbarProps, "children"> {
    title: string;
    severity: AlertProps["severity"];
    onClose: () => void;
    icon?: ReactNode;
    children: ReactElement;
}

const SIX_SECONDS = 6000;

export function Toast({ title, severity, children, onClose, icon, ...props }: ToastProps) {
    return (
        <Snackbar
            autoHideDuration={SIX_SECONDS}
            onClose={onClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            {...props}
        >
            <div className="flex min-w-xs w-md max-w-[calc(100vw-32px)] flex-col overflow-hidden rounded-xl bg-white shadow-lg">
                <Alert
                    onClose={onClose}
                    severity={severity}
                    variant="standard"
                    icon={icon}
                    className="rounded-none px-4 py-2 flex items-center"
                    sx={{
                        bgcolor: "rgb(18, 115, 112)",
                        color: "#fff",
                        fontSize: "20px",
                        fontWeight: 500,
                        letterSpacing: "0.2px",
                        ".MuiAlert-title": { fontSize: "20px", fontWeight: 500, letterSpacing: "0.2px" },
                        ".MuiAlert-icon": { color: "#fff" },
                        ".MuiAlert-action": { color: "#fff" },
                        ".MuiAlert-message": { padding: 0 },
                    }}
                >
                    <span className="text-white text-[20px] leading-[24px] font-medium tracking-[0.2px]">{title}</span>
                </Alert>
                <div className="bg-white px-6 py-5">{children}</div>
            </div>
        </Snackbar>
    );
}
